import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Stack, Typography } from "@mui/material";

import colors from "../../../../../utils/colors";
import LayerdIcon from "../../../../common/LayerdIcon";
import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import {
  spNetworkDetailCardTitleSx,
  spRequestHeadersCardSx,
  spRequestHeaderLabelSx,
  spRequestHeaderValueSx,
} from "./smartParseDrawerUi";

export default function RequestHeadersSection({ userAgent, onCopy }) {
  if (!userAgent) return null;

  return (
    <Box sx={spRequestHeadersCardSx}>
      <Stack spacing={1.5}>
        <Typography sx={spNetworkDetailCardTitleSx}>Request headers</Typography>
        <Box>
          <Typography sx={spRequestHeaderLabelSx}>User-Agent</Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography sx={{ ...spRequestHeaderValueSx, flex: 1 }}>{userAgent}</Typography>
            {onCopy && (
              <IconButton
                size="small"
                onClick={() => onCopy(userAgent)}
                aria-label="Copy User-Agent"
                sx={{
                  width: 28,
                  height: 28,
                  flexShrink: 0,
                  color: colors.neutral[500],
                  "&:hover": { backgroundColor: colors.primary[100] },
                }}
              >
                <LayerdIcon icon={DETECTION_ICONS.copy} size={14} color="neutral" />
              </IconButton>
            )}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}

RequestHeadersSection.propTypes = {
  userAgent: PropTypes.string,
  onCopy: PropTypes.func,
};
